import { Link, useLocation } from 'react-router-dom';

// Estilos del texto legal: columna de lectura cómoda, colores del sistema
const h1Style: React.CSSProperties = {
  color: 'rgb(var(--ink))',
  fontSize: '2rem',
  fontWeight: 700,
  letterSpacing: '-0.024em',
  lineHeight: 1.15,
  margin: '0 0 6px',
};

const dateStyle: React.CSSProperties = {
  color: 'rgb(var(--ink-2))',
  fontSize: '0.8125rem',
  margin: '0 0 32px',
};

const h2Style: React.CSSProperties = {
  color: 'rgb(var(--ink))',
  fontSize: '1.125rem',
  fontWeight: 600,
  letterSpacing: '-0.014em',
  margin: '32px 0 8px',
};

const pStyle: React.CSSProperties = {
  color: 'rgb(var(--ink-2))',
  fontSize: '1rem',
  lineHeight: 1.65,
  margin: '0 0 12px',
};

const dividerStyle: React.CSSProperties = {
  height: 1,
  background: 'rgb(var(--line))',
  margin: '32px 0',
};

function PrivacyPolicy() {
  return (
    <>
      <h1 style={h1Style}>Política de Privacidad</h1>
      <p style={dateStyle}>Última actualización: octubre 2026</p>

      <p style={pStyle}>
        En Jugaly nos tomamos en serio la privacidad de nuestros usuarios. Esta política explica qué datos recogemos, cómo los usamos y cuáles son tus derechos.
      </p>

      <h2 style={h2Style}>1. Responsable del tratamiento</h2>
      <p style={pStyle}>
        José Manuel Benítez Ruiz<br />
        Email: info@jugaly.es
      </p>

      <h2 style={h2Style}>2. Datos que recogemos</h2>
      <p style={pStyle}>
        Al registrarte recogemos: nombre de usuario, dirección de correo electrónico y contraseña (almacenada de forma cifrada). No recogemos datos de pago ni información personal adicional.
      </p>
      <p style={pStyle}>
        Adicionalmente, guardamos datos de uso del servicio como partidas jugadas, resultados, nivel y puntuaciones. Tu nombre de usuario y tus mejores puntuaciones se muestran públicamente en el ranking de cada juego.
      </p>

      <h2 style={h2Style}>3. Finalidad del tratamiento</h2>
      <p style={pStyle}>
        Usamos tus datos para: gestionar tu cuenta, permitirte jugar, enviarte notificaciones del servicio (bienvenida, cambio de contraseña) y mejorar la plataforma.
      </p>

      <h2 style={h2Style}>4. Base legal</h2>
      <p style={pStyle}>
        El tratamiento se basa en la ejecución del contrato de uso del servicio (art. 6.1.b RGPD) y el interés legítimo en el correcto funcionamiento de la plataforma.
      </p>

      <h2 style={h2Style}>5. Conservación de datos</h2>
      <p style={pStyle}>
        Conservamos tus datos mientras tu cuenta esté activa. Si solicitas la eliminación de tu cuenta, borraremos tus datos personales en un plazo máximo de 30 días.
      </p>

      <h2 style={h2Style}>6. Tus derechos</h2>
      <p style={pStyle}>
        Tienes derecho a acceder, rectificar, suprimir, limitar y portabilizar tus datos. Para ejercerlos, escríbenos a info@jugaly.es. También puedes presentar una reclamación ante la Agencia Española de Protección de Datos (aepd.es).
      </p>

      <h2 style={h2Style}>7. Cookies</h2>
      <p style={pStyle}>
        Jugaly utiliza únicamente cookies técnicas necesarias para el funcionamiento del servicio (sesión de usuario). No utilizamos cookies de seguimiento ni publicidad de terceros.
      </p>

      <h2 style={h2Style}>8. Seguridad</h2>
      <p style={pStyle}>
        Aplicamos medidas técnicas de seguridad como cifrado de contraseñas, HTTPS y control de acceso para proteger tus datos.
      </p>
    </>
  );
}

function TermsOfUse() {
  return (
    <>
      <h1 style={h1Style}>Términos de Uso</h1>
      <p style={dateStyle}>Última actualización: octubre 2026</p>

      <p style={pStyle}>
        Al usar Jugaly aceptas estos términos. Por favor, léelos antes de registrarte.
      </p>

      <h2 style={h2Style}>1. El servicio</h2>
      <p style={pStyle}>
        Jugaly es una plataforma de juegos para el navegador (Buscaminas, Snake y otros que se irán añadiendo) para jugar en solitario, con un ranking por juego para los usuarios registrados. El servicio se ofrece de forma gratuita y sin garantías de disponibilidad continua.
      </p>

      <h2 style={h2Style}>2. Registro</h2>
      <p style={pStyle}>
        Debes tener al menos 18 años para registrarte y usar Jugaly. Eres responsable de mantener la confidencialidad de tu contraseña y de toda la actividad que ocurra bajo tu cuenta.
      </p>

      <h2 style={h2Style}>3. Conducta</h2>
      <p style={pStyle}>
        Queda prohibido: usar trampas, programas o bots para manipular partidas o puntuaciones del ranking, elegir nombres de usuario ofensivos, o intentar comprometer la seguridad de la plataforma. El incumplimiento puede resultar en la suspensión de tu cuenta y la retirada de tus puntuaciones.
      </p>

      <h2 style={h2Style}>4. Juego social — sin apuestas reales</h2>
      <p style={pStyle}>
        Jugaly es una plataforma de entretenimiento. Todos los juegos se juegan sin apuestas de ningún tipo. Jugaly <strong style={{ color: 'rgb(var(--ink))' }}>no es una plataforma de juego de azar con dinero real</strong>, no requiere ni posee licencia de juego, y no está sujeta a la Ley 13/2011 de regulación del juego en lo relativo a operadores de juego online.
      </p>
      <p style={pStyle}>
        No se realizan apuestas con dinero real en ningún momento. Ningún resultado en Jugaly tiene valor económico ni puede convertirse en dinero, bienes o servicios de ningún tipo.
      </p>

      <h2 style={h2Style}>5. Disponibilidad</h2>
      <p style={pStyle}>
        Jugaly se ofrece "tal cual". No garantizamos disponibilidad ininterrumpida y nos reservamos el derecho de modificar o interrumpir el servicio en cualquier momento.
      </p>

      <h2 style={h2Style}>6. Propiedad intelectual</h2>
      <p style={pStyle}>
        El código, diseño y contenido de Jugaly pertenecen a José Manuel Benítez Ruiz. No está permitida su reproducción sin autorización.
      </p>

      <h2 style={h2Style}>7. Limitación de responsabilidad</h2>
      <p style={pStyle}>
        No nos hacemos responsables de daños derivados del uso o imposibilidad de uso del servicio. El uso de Jugaly es bajo tu propia responsabilidad.
      </p>

      <h2 style={h2Style}>8. Cambios en los términos</h2>
      <p style={pStyle}>
        Podemos actualizar estos términos en cualquier momento. Los cambios se publicarán en esta página con la fecha de actualización.
      </p>

      <h2 style={h2Style}>9. Contacto</h2>
      <p style={pStyle}>
        Para cualquier consulta sobre estos términos escríbenos a info@jugaly.es.
      </p>
    </>
  );
}

function LegalNotice() {
  return (
    <>
      <h1 style={h1Style}>Aviso Legal</h1>
      <p style={dateStyle}>Última actualización: octubre 2026</p>

      <h2 style={h2Style}>Titular del sitio web</h2>
      <p style={pStyle}>
        <strong style={{ color: 'rgb(var(--ink))' }}>Nombre:</strong> José Manuel Benítez Ruiz<br />
        <strong style={{ color: 'rgb(var(--ink))' }}>Email:</strong> info@jugaly.es<br />
        <strong style={{ color: 'rgb(var(--ink))' }}>Web:</strong> jugaly.es
      </p>

      <div style={dividerStyle} />

      <h2 style={h2Style}>Objeto</h2>
      <p style={pStyle}>
        El presente aviso legal regula el uso del sitio web jugaly.es, titularidad de José Manuel Benítez Ruiz. El acceso y uso de este sitio web implica la aceptación plena de este aviso legal.
      </p>

      <h2 style={h2Style}>Propiedad intelectual</h2>
      <p style={pStyle}>
        Todos los contenidos del sitio web (diseño, código fuente, imágenes, textos) son propiedad de José Manuel Benítez Ruiz o de sus respectivos autores, y están protegidos por la legislación española e internacional sobre propiedad intelectual. Queda prohibida su reproducción total o parcial sin autorización expresa.
      </p>

      <h2 style={h2Style}>Legislación aplicable</h2>
      <p style={pStyle}>
        Este aviso legal se rige por la legislación española, en particular la Ley 34/2002 de Servicios de la Sociedad de la Información (LSSI) y el Reglamento General de Protección de Datos (RGPD).
      </p>
    </>
  );
}

export default function Legal() {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-10 sm:pt-14 pb-20">
      <nav className="mb-10" aria-label="Documentos legales">
        <div className="segmented">
          {[
            { to: '/privacidad', label: 'Privacidad' },
            { to: '/terminos', label: 'Términos de uso' },
            { to: '/aviso-legal', label: 'Aviso legal' },
          ].map((l) => (
            <Link key={l.to} to={l.to} className="segment inline-flex items-center" aria-pressed={path === l.to} aria-current={path === l.to ? 'page' : undefined}>
              {l.label}
            </Link>
          ))}
        </div>
      </nav>

      <article className="max-w-[68ch]">
        {path === '/privacidad' && <PrivacyPolicy />}
        {path === '/terminos' && <TermsOfUse />}
        {path === '/aviso-legal' && <LegalNotice />}
      </article>
    </div>
  );
}
